import { TContent } from '@/types/Content.types';

// `ContentDto.details` is typed as a union of three shapes and is effectively opaque at
// the call site, so the loop narrows it once here rather than casting inline everywhere.

export type TContentSection = {
  _id?: string;
  title?: string;
  text?: string;
  imageUrl?: string | null;
};

export type TContentDetails = {
  body?: string;
  sections?: TContentSection[];
  source?: string;
  fullDescription?: string;
  mux?: { playbackId?: string; status?: string; thumbnailUrl?: string; durationSeconds?: number };
  youtube?: { videoId?: string; durationSeconds?: number };
};

export const readDetails = (content: TContent): TContentDetails => (content.details ?? {}) as TContentDetails;

export const getDurationSeconds = (content: TContent): number | null => {
  const details = readDetails(content);

  return details.mux?.durationSeconds ?? details.youtube?.durationSeconds ?? null;
};

// Sections worth showing as chips — untitled ones are body copy, not navigable sections.
export const getTitledSections = (content: TContent): TContentSection[] =>
  (readDetails(content).sections ?? []).filter((section) => section.title);
